import { FormControl, InputLabel } from '@mui/material';

import MyDialog from "~/mui/MyDialog";
import { useTrans } from "~/hooks/useTrans";
import { MySelect, MyMenuItem } from "~/mui/MySelect";
import { apiTransferProject } from "~/providers/api";
import { IUrlParams, IFetchOutput } from "~/interfaces";
import { myUseState } from "~/hooks/myUseState";
import { useLang } from "~/hooks/useLang";

import "./style.less";

interface IState {
	users: Array<string>;
	newOwnerEmail: string;
	dialogLoading: boolean;
	errorMsg: string;
}

interface IForwardOwnerShipModal {
	params: IUrlParams;
	isInternal: boolean;
	projectLastUpdate: string;
	users: Array<string>;
	onClose?: () => void;
	onSave?: (email: string) => void;
}

export default function ForwardOwnerShipModal({
	params = null,
	isInternal = false,
	projectLastUpdate = "",
	users = [],
	onClose = () => {},
	onSave = () => {},
}: IForwardOwnerShipModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>({
		users,
		newOwnerEmail: users.length ? users[0] : "",
		dialogLoading: false,
		errorMsg: "",
	});

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		let outputData: IFetchOutput<null> = null;

		if (isInternal) {
			outputData = await apiTransferProject("admin", params.projectId, {
				newOwnerEmail: state.newOwnerEmail,
				lastUpdate: projectLastUpdate,
			}, lang);
		} else {
			outputData = await apiTransferProject("client", params.projectId, {
				newOwnerEmail: state.newOwnerEmail,
				lastUpdate: projectLastUpdate,
			}, lang);
		}

		if (outputData.noErrors) {
			onSave(state.newOwnerEmail);
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: outputData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("usersPage.btnForwardOwnership")} onClose={onClose} onSave={dialogOnSave} dialogLoading={state.dialogLoading} errorMsg={state.errorMsg}
		cancelCaption={ trans("cancel") } saveCaption={ trans("usersPage.btnForwardOwnership") } className="forwardOwnerShipModal">
		<h2 className="forwardOwnerShipModal__title">
			{ trans("usersPage.chooseNewOwner") }
		</h2>
		<div>
			<FormControl size="small" className="langSwitcher">
				<InputLabel>{ trans("usersPage.ownerList") }</InputLabel>
				<MySelect value={state.newOwnerEmail} onChange={event => updateState({ newOwnerEmail: event.target.value as string })} label={ trans("usersPage.ownerList") }>
					{ state.users.map(email => <MyMenuItem value={email} key={email}>
						{ email }
					</MyMenuItem>) }
				</MySelect>
			</FormControl>
		</div>
	</MyDialog>;
}
